module.exports = "assets/5c126a676569d82870da2393dcd304f2.glb";